export const messages = {
  breadcrumbs: {
    home: 'Home',
    about: 'About',
    termAndConditions: 'Terms & Conditions',
    privacyPolicy: 'Privacy Policy',
    studies: 'Studies',
  },
};
